
const state = {
  attachable_id: undefined,
  attachable_type: '',
  attachment_type: '',
  data: {},
  file: '',
  file_content_type: '',
  file_file_name: '',
  id: null,
}

export const requiredFields = [
  { key: 'attachable_id' },
  { key: 'attachable_type' },
]

export default state
